import angular from '../assets/img/angular.svg'
import bootstrap from '../assets/img/bootstrap.svg'
import css from '../assets/img/css3.svg'
import figma from '../assets/img/figma.svg'
import firebase from '../assets/img/firebase-icon.svg'
import html from '../assets/img/html.svg'
import javascript from '../assets/img/javascript.svg'
import materialUi from '../assets/img/material-ui.svg'
import nextjs from '../assets/img/nextjs.svg'
import nodejs from '../assets/img/nodejs.svg'
import postgresql from '../assets/img/postgresql.svg'
import programmer from '../assets/img/programmer.svg'
import question from '../assets/img/question.svg'
import react from '../assets/img/react.svg'
import redux from '../assets/img/redux.svg'
import sass from '../assets/img/sass.svg'
import styledComponents from '../assets/img/styledComponentsLogo.svg'
import supabase from '../assets/img/supabase.svg'
import tailwindcss from '../assets/img/tailwindcss.svg'
import typescript from '../assets/img/typescript.svg'
import wordpress from '../assets/img/wordpress.svg'

const CategoryToImageMap = {
	HTML: html,
	JavaScript: javascript,
	Angular: angular,
	TypeScript: typescript,
	React: react,
	CSS: css,
	SASS: sass,
	Bootstrap: bootstrap,
	'Material UI': materialUi,
	Wordpress: wordpress,
	'Styled Components': styledComponents,
	Firebase: firebase,
	Figma: figma,
	NodeJS: nodejs,
	'Node.js': nodejs,
	NextJS: nextjs,
	'Next.js': nextjs,
	Redux: redux,
	Supabase: supabase,
	PostgreSQL: postgresql,
	'Tailwind CSS': tailwindcss,
	'Today I learned': programmer,
	question: question,
}

export default CategoryToImageMap
